/*
 * Emblyss - shared scroll reveal.
 *
 * One behaviour for the whole page: anything marked [data-reveal] rises a short
 * distance and fades as it enters the viewport. Fires ONCE and is then
 * unobserved - re-animating on every scroll past makes a page feel cheap.
 *
 * The hidden state lives behind html.em-js, a class set synchronously in the
 * head (see snippets/emblyss-brand.liquid). That ordering matters both ways:
 *   - set in the head, so content is never painted visible then yanked hidden
 *   - gated on JS at all, so if scripts are blocked the page renders fully
 *     visible rather than staying blank
 *
 * Stagger is passed per element as --rd, a transition-delay. Grouping happens
 * in the Liquid, not here, so each section sets its own rhythm.
 */
(function () {
  'use strict';

  // Several sections include this file; run the setup only once.
  if (window.__emblyssReveal) return;
  window.__emblyssReveal = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-reveal]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('em-revealed');
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  if (reduced.matches || !('IntersectionObserver' in window)) {
    onReady(function () { revealAll(); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('em-revealed');
        observer.unobserve(entries[i].target);
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
  );

  function observe(scope) {
    var nodes = (scope || document).querySelectorAll('[data-reveal]:not(.em-revealed)');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Anything already on screen at load reveals straight away, rather than
      // waiting for a scroll that may never come on a short page.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        el.classList.add('em-revealed');
      } else {
        observer.observe(el);
      }
    }
  }

  onReady(function () { observe(); });

  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  if (typeof reduced.addEventListener === 'function') {
    reduced.addEventListener('change', function () {
      if (reduced.matches) {
        observer.disconnect();
        revealAll();
      }
    });
  }
})();
